import React, { useState } from 'react';
import styled from 'styled-components';
import { FaArrowLeft, FaArrowRight, FaDownload, FaShareAlt } from 'react-icons/fa';
import {
  OverlayContainer,
  ImageContainer,
  Image,
  ArrowButton,
  TopBar,
  ImageName,
  ButtonContainer,
  ActionButton,
  OverlayWrapper,
  OverlayContent,
} from './PreviewCarousel.styles.js';
import { useDispatch } from 'react-redux';
import { togglePreviewModal } from '../../../redux/reducers/newhotbar.js';
import { handleDownloadImage } from '../../../utils/helpers.js';
import { toast } from 'react-toastify';

const PreviewCarousel = ({ selectedImage, imageArray, onViewInWheel }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(imageArray.indexOf(selectedImage));

  // Handlers to navigate through images
  const showPreviousImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? imageArray.length - 1 : prevIndex - 1));
  };

  const showNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === imageArray.length - 1 ? 0 : prevIndex + 1));
  };

  const handlecopyToClipboard = () => {
    navigator.clipboard
      .writeText(currentImage)
      .then(() => {
        toast.success('Image copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy URL: ', err);
      });
  };

  const currentImage = imageArray[currentImageIndex]?.src;

  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(togglePreviewModal());
  };
  return (
    <OverlayWrapper onClick={onClose}>
      <OverlayContent onClick={(e) => e.stopPropagation()}>
        <OverlayContainer>
          <ArrowButton onClick={showPreviousImage} position="left">
            <FaArrowLeft size={20} />
          </ArrowButton>

          <ImageContainer>
            <Image src={currentImage} alt="Displayed Image" />
          </ImageContainer>

          <ArrowButton onClick={showNextImage} position="right">
            <FaArrowRight size={20} />
          </ArrowButton>

          <TopBar>
            <ImageName>{currentImage?.title}</ImageName>
            <ButtonContainer>
              {/* <ActionButton onClick={onViewInWheel}>View on wheel</ActionButton> */}
              <ActionButton>
                <FaShareAlt onClick={handlecopyToClipboard} />
              </ActionButton>
              <ActionButton onClick={() => handleDownloadImage(currentImage)}>
                <FaDownload />
              </ActionButton>
            </ButtonContainer>
          </TopBar>
        </OverlayContainer>
      </OverlayContent>
    </OverlayWrapper>
  );
};

export default PreviewCarousel;
